// extracted by mini-css-extract-plugin
export var option = "_da-0";
export var optionCard = "_da-f";
export var optionContent = "_da-g";
export var optionIcon = "_da-i";
export var optionIconBox = "_da-h";
export var optionLabel = "_da-j";
export var optionPill = "_da-m";
export var optionPillBadge = "_da-p";
export var optionPillIcon = "_da-n";
export var optionPillLabel = "_da-o";
export var optionRadio = "_da-k";
export var optionRadioInner = "_da-l";
export var optionReveal = "_da-2";
export var optionRevealDelay0 = "_da-3";
export var optionRevealDelay1 = "_da-4";
export var optionRevealDelay10 = "_da-d";
export var optionRevealDelay11 = "_da-e";
export var optionRevealDelay2 = "_da-5";
export var optionRevealDelay3 = "_da-6";
export var optionRevealDelay4 = "_da-7";
export var optionRevealDelay5 = "_da-8";
export var optionRevealDelay6 = "_da-9";
export var optionRevealDelay7 = "_da-a";
export var optionRevealDelay8 = "_da-b";
export var optionRevealDelay9 = "_da-c";
export var optionSelected = "_da-1";